import { type FC } from 'react';

import { IconArrowLeft, IconPlayerPlay } from '@tabler/icons-react';
import { ButtonField, ButtonFieldIcon } from '@wk/components-react16';

import type { SiteComplianceSite } from '@/domains/siteCompliance';

interface SiteDetailHeaderProps {
  isMobileViewport: boolean;
  onBack: () => void;
  onRunEvaluation: () => void;
  site: SiteComplianceSite | null;
}

const SiteDetailHeader: FC<SiteDetailHeaderProps> = ({
  isMobileViewport,
  onBack,
  onRunEvaluation,
  site,
}) => (
  <div className="flex w-full items-center justify-between gap-3">
    <div className="flex min-w-0 items-center gap-4">
      <ButtonFieldIcon size="small24px">
        <button type="button" aria-label="Back to Site Compliance" onClick={onBack}>
          <IconArrowLeft />
        </button>
      </ButtonFieldIcon>
      <h1 className="min-w-0 font-medium whitespace-normal break-words leading-tight sm:truncate">
        {site ? site.siteName : 'Site Details'}
      </h1>
    </div>

    {site && isMobileViewport ? (
      <div className="flex items-center gap-2">
        <ButtonField mode="ghost" size="small">
          <button
            type="button"
            aria-label="Run evaluation"
            onClick={onRunEvaluation}
          >
            <IconPlayerPlay size={14} />
          </button>
        </ButtonField>
      </div>
    ) : null}
  </div>
);

export default SiteDetailHeader;
